import { render, staticRenderFns } from "./MessagesDemo.vue?vue&type=template&id=1efec9ac&scoped=true&"
import script from "./MessagesDemo.vue?vue&type=script&lang=js&"
export * from "./MessagesDemo.vue?vue&type=script&lang=js&"
import style0 from "./MessagesDemo.vue?vue&type=style&index=0&id=1efec9ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1efec9ac",
  null
  
)

export default component.exports